import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Almost every fresh session redirects '' -> 'home', so the home lazy chunk is needed
 * within moments of bootstrap. Without preloading it, the router only starts that
 * import() after the auth guard resolves - a full extra network round trip stacked
 * onto the home page's LCP on slow connections. This strategy preloads only routes
 * explicitly opted in via `data: { preload: true }`, in the background once the app
 * is idle, instead of Angular's built-in PreloadAllModules (which would preload all
 * ~29 lazy routes and compete for bandwidth with the actual home page data/image).
 */
@Injectable({ providedIn: 'root' })
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    return route.data?.['preload'] ? load() : of(null);
  }
}
